export const breadcrumb = {
  root: {
    padding: "{padding.12} 0",
    background: "transparent",
    gap: "{gap.8}",
    transitionDuration: "{transition.duration}",
  },
  item: {
    color: "{text.caption}",
    hoverColor: "{text.body}",
    borderRadius: "{border.radius.4}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{text.caption}",
      hoverColor: "{text.body}",
    },
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  separator: {
    color: "{text.subtle-text}",
  },
  css: ({ dt }: any): string => `
    .p-breadcrumb-item-link {
      cursor: pointer;
      font-size: ${dt("content.font.size")};
      line-height: ${dt("content.font.leading")};
    }

    /* The last item is the current level, so it reads like a title and isn't clickable */
    .p-breadcrumb-item:last-child .p-breadcrumb-item-link {
      cursor: default;
      color: ${dt("text.body")};
      font-weight: 600;
    }
  `,
};
